module.exports = __webpack_public_path__ + "img/fc-porto.c22bbf7b.png";